// extracted by mini-css-extract-plugin
export default {"close":"Button_close__CdSe6","closeInner":"Button_closeInner__ZNJ7r"};